import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthHttpInterceptor } from '@app/http-interceptors/auth-http-interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
];
